import React, { useState } from "react";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useNavigate } from "react-router-dom";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Button from "../..//Elements/Button/Button.js";

const SideBarContentHolder = ({
  children,
  headerName,
  headerIcon,
  itemCommentsCount,
}) => {
  const { closeSlideBar } = useSideBar();
  const [touchStartPosition, setTouchStartPosition] = useState();
  const { getMailMetaData } = useMail();
  const navigate = useNavigate();
  const commentsQuantity = itemCommentsCount || getMailMetaData().CommentCount;

  const handleCloseSidebar = () => {
    if (window.location.search.length > 0) {
      navigate({
        search: "",
      });
    }
    closeSlideBar();
  };

  return (
    <>
      <div
        className="side-bar-header"
        onTouchStart={(e) => {
          setTouchStartPosition(e.touches[0].clientY);
        }}
        onTouchMove={(e) =>
          e.touches[0].clientY - touchStartPosition > 100
            ? handleCloseSidebar()
            : null
        }
        onTouchEnd={(e) => setTouchStartPosition(null)}
      >
        <div className="name-section">
          {commentsQuantity && headerIcon.includes("comment") ? (
            <div className="comments-count-number">{commentsQuantity}</div>
          ) : null}
          <Icon name={headerIcon} blue />
          <span>{headerName}</span>
        </div>
        <div className="sidebar-close-button">
          <Button onClick={handleCloseSidebar} close>
            <Tooltip
              id={"closeSideBar"}
              tooltipTextKey="close-sidebar-tooltip-text"
              top
            >
              <Icon large name="x" gray></Icon>
            </Tooltip>
          </Button>
        </div>
      </div>
      <hr />
      <div className="side-bar-content">{children}</div>
    </>
  );
};

export default SideBarContentHolder;
